import { render, staticRenderFns } from "./JsonDetails.vue?vue&type=template&id=0a4c0e7c&"
import script from "./JsonDetails.vue?vue&type=script&lang=js&"
export * from "./JsonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports